const subtopicsData = {
  Science: [
    {
      title: "Mathematics",
      image: require("../assets/images/courses/mathematics.png"),
      color: "#FF9283",
    },
    {
      title: "Physics",
      image: require("../assets/images/courses/physics.png"),
      color: "#407BFF",
    },
    {
      title: "Chemistry",
      image: require("../assets/images/courses/Microscope.png"),
      color: "#15E4B9",
    },
    {
      title: "Biology",
      image: require("../assets/images/courses/bio.png"),
      color: "#EBC33C",
    },
  ],
  Commerce: [
    {
      title: "Accountancy",
      image: require("../assets/images/courses/accounting.png"),
      color: "#EB76FF",
    },
    {
      title: "Economics",
      image: require("../assets/images/courses/economy.png"),
      color: "#FF725E",
    },
    {
      title: "Business Studies",
      image: require("../assets/images/courses/business.png"),
      color: "#3EB7FB",
    },
    {
      title: "Mathematics",
      image: require("../assets/images/courses/business.png"),
      color: "#F0997A",
    },
  ],
  "Humanities & Social Sciences": [
    {
      title: "History",
      image: require("../assets/images/courses/history.png"),
      color: "#0ED2FC",
    },
    {
      title: "Political Science",
      image: require("../assets/images/courses/political.png"),
      color: "#FF99BA",
    },
    {
      title: "Geography",
      image: require("../assets/images/courses/geography.png"),
      color: "#FFD700",
    },
    {
      title: "Psychology",
      image: require("../assets/images/courses/psycology.png"),
      color: "#29C7AC",
    },
    {
      title: "Sociology",
      image: require("../assets/images/courses/Sociology.png"),
      color: "#FFA069",
    },
    {
      title: "Physical Education",
      image: require("../assets/images/courses/physical_education.png"),
      color: "#7EB77F",
    },
  ],
};

const subtopicsData1 = [
  {
    title: "Mathematics",
    image: require("../assets/images/courses/mathematics.png"),
    color: "#FF9283",
  },
  {
    title: "Physics",
    image: require("../assets/images/courses/physics.png"),
    color: "#407BFF",
  },
  {
    title: "Chemistry",
    image: require("../assets/images/courses/Microscope.png"),
    color: "#15E4B9",
  },
  {
    title: "Biology",
    image: require("../assets/images/courses/bio.png"),
    color: "#EBC33C",
  },
  {
    title: "Accountancy",
    image: require("../assets/images/courses/accounting.png"),
    color: "#EB76FF",
  },
  {
    title: "Economics",
    image: require("../assets/images/courses/economy.png"),
    color: "#FF725E",
  },
  {
    title: "Business Studies",
    image: require("../assets/images/courses/business.png"),
    color: "#3EB7FB",
  },
  {
    title: "History",
    image: require("../assets/images/courses/history.png"),
    color: "#0ED2FC",
  },
  {
    title: "Political Science",
    image: require("../assets/images/courses/political.png"),
    color: "#FF99BA",
  },
  {
    title: "Geography",
    image: require("../assets/images/courses/geography.png"),
    color: "#FFD700",
  },
  {
    title: "Psychology",
    image: require("../assets/images/courses/psycology.png"),
    color: "#29C7AC",
  },
  {
    title: "Sociology",
    image: require("../assets/images/courses/Sociology.png"),
    color: "#FFA069",
  },
  {
    title: "Physical Education",
    image: require("../assets/images/courses/physical_education.png"),
    color: "#7EB77F",
  },
];

const subtopicsData2 = [
  {
    title: "General English",
    image: require("../assets/images/courses/domain1.png"),
    color: "#FA8072",
  },
  {
    title: "General Test",
    image: require("../assets/images/courses/domain3.png"),
    color: "#976391",
  },
  {
    title: "Mathematics",
    image: require("../assets/images/courses/mathematics.png"),
    color: "#FF9283",
  },
  {
    title: "Physics",
    image: require("../assets/images/courses/physics.png"),
    color: "#407BFF",
  },
  {
    title: "Chemistry",
    image: require("../assets/images/courses/Microscope.png"),
    color: "#15E4B9",
  },
  {
    title: "Biology",
    image: require("../assets/images/courses/bio.png"),
    color: "#EBC33C",
  },
  {
    title: "Accountancy",
    image: require("../assets/images/courses/accounting.png"),
    color: "#EB76FF",
  },
  {
    title: "Economics",
    image: require("../assets/images/courses/economy.png"),
    color: "#FF725E",
  },
  {
    title: "Business Studies",
    image: require("../assets/images/courses/business.png"),
    color: "#3EB7FB",
  },
  {
    title: "History",
    image: require("../assets/images/courses/history.png"),
    color: "#0ED2FC",
  },
  {
    title: "Political Science",
    image: require("../assets/images/courses/political.png"),
    color: "#FF99BA",
  },
  {
    title: "Geography",
    image: require("../assets/images/courses/geography.png"),
    color: "#FFD700",
  },
  {
    title: "Psychology",
    image: require("../assets/images/courses/psycology.png"),
    color: "#29C7AC",
  },
  {
    title: "Sociology",
    image: require("../assets/images/courses/Sociology.png"),
    color: "#FFA069",
  },
  {
    title: "Physical Education",
    image: require("../assets/images/courses/physical_education.png"),
    color: "#7EB77F",
  },
];

const DomainTopic = [
  {
    title: "Science",
    image: require("../assets/images/courses/mathematics.png"),
    color: "#BC85FF",
  },
  {
    title: "Commerce",
    image: require("../assets/images/courses/commerce.png"),
    color: "#6A5EFF",
  },
  {
    title: "Humanities & Social Sciences",
    image: require("../assets/images/courses/Microscope.png"),
    color: "#47C8FF",
  },
];

export { DomainTopic, subtopicsData, subtopicsData1, subtopicsData2 };
